import React from 'react';
import './App.css';
import MainContainer from './components/Container';
import Title from './components/Title';


function App() {
  return (
    <div>
      <Title />
      <MainContainer />
    </div>
  );
}


export default App;
